import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../common/Loader";
import {
  fetchGrievances,
  fetchGrievancesBySection,
  fetchIDCard,
  fetchGrants,
  fetchGrantsBySection,
  fetchDashboardCount,
  fetchCenters,
} from "../../redux/actions/grievanceActions1";
import {
  Users,
  CreditCard,
  Gift,
  FileText,
  TrendingUp,
  Calendar,
} from "lucide-react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

import { StatCard, DashboardHeader } from "../common/DashboardComponents";
import { renderTable, getRoleConfig } from "../common/DashboardComponent";

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Move ALL useState hooks to the top
  const [userRole, setUserRole] = useState(3);
  const [centerId, setCenterId] = useState("");
  const [userTimeframe, setUserTimeframe] = useState("total");
  const [idCardTimeframe, setIdCardTimeframe] = useState("total");
  const [grantTimeframe, setGrantTimeframe] = useState("total");
  const [grievanceTimeframe, setGrievanceTimeframe] = useState("total");
  const [isPendingAt, setIsPendingAt] = useState("");

  // Move ALL useSelector hooks to the top
  const {
    grievances,
    loading: grievancesLoading,
    loading: grantsLoading,
    idCard,
    grants,
    userDashborad,
    idcardDashborad,
    grantDashborad,
    grievanceDashborad,
    grantsescalaratedDashboard,
    grievancesescalaratedDashboard,
    eventsDashboard,
    centers,
  } = useSelector((state) => state.grievances);
  console.log(grantDashborad, "grantDashborad444");

  // Move ALL useEffect hooks to the top
  useEffect(() => {
    try {
      const userData = JSON.parse(localStorage.getItem("user"));

      if (userData && userData.role) {
        setUserRole(userData.role);
        setCenterId(userData?.UNIT_CENTRE_ID);
        // Fetch grievances based on role
        if (userData.role === 9) {
          console.log(
            "Dashboard - Fetching grievances for section:",
            userData.UNIT_CENTRE_ID
          );
          dispatch(fetchGrievancesBySection(userData.UNIT_CENTRE_ID));
        } else if (userData.role === 10) {
          console.log("Dashboard - Fetching grants for section: 10");
          dispatch(fetchGrantsBySection(userData.UNIT_CENTRE_ID));
        } else if (userData.role === 11) {
          dispatch(fetchIDCard());
        } else {
          dispatch(fetchGrievances());
          dispatch(fetchGrants());
        }
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
      // Fallback if there's an error
      dispatch(fetchGrievances());
      dispatch(fetchGrants());
    }
  }, [dispatch]);

  useEffect(() => {
    const customStyle = document.createElement("style");
    customStyle.textContent = `
      .modern-card {
        background: #ffffff;
        border: 1px solid #e2e8f0;
        border-radius: 16px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        transition: all 0.3s ease;
        overflow: hidden;
      }
      
      .modern-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
        border-color: #cbd5e1;
      }
      
      .stat-card {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        border-radius: 20px;
        padding: 24px;
        position: relative;
        overflow: hidden;
      }
      
      .stat-card::before {
        content: '';
        position: absolute;
        top: -50%;
        right: -20px;
        width: 100px;
        height: 100px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 50%;
      }
      
      .icon-wrapper {
        width: 64px;
        height: 64px;
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 16px;
        position: relative;
        z-index: 2;
      }
      
      .icon-blue { background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%); }
      .icon-green { background: linear-gradient(135deg, #10b981 0%, #059669 100%); }
      .icon-purple { background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%); }
      .icon-orange { background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); }
      
      .progress-ring {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background: conic-gradient(#667eea 0deg, #667eea var(--progress), #e2e8f0 var(--progress), #e2e8f0 360deg);
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
      }
      
      .progress-ring::after {
        content: '';
        width: 40px;
        height: 40px;
        background: white;
        border-radius: 50%;
        position: absolute;
      }
      
      .chart-container {
        background: #ffffff;
        border: 1px solid #e2e8f0;
        border-radius: 16px;
        padding: 24px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
        height: 100%;
        display: flex;
        flex-direction: column;
      }
      
      .chart-content {
        flex: 1;
        display: flex;
        flex-direction: column;
      }
      
      .equal-height-card {
        height: 450px;
        display: flex;
        flex-direction: column;
      }
      
      .pie-chart-legend {
        max-height: 120px;
        overflow-y: auto;
        padding: 12px 0;
      }
      
      .legend-item-compact {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        font-size: 0.85rem;
      }
      
      .legend-color {
        width: 12px;
        height: 12px;
        border-radius: 3px;
        margin-right: 8px;
        flex-shrink: 0;
      }
      
      .chart-dropdown {
        position: absolute;
        top: 20px;
        right: 20px;
        background: #f8fafc;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        padding: 2px;
        z-index: 10;
      }
      
      .chart-dropdown select {
        background: transparent;
        border: none;
        color: #374151;
        font-size: 12px;
        font-weight: 500;
        padding: 6px 10px;
        border-radius: 6px;
        cursor: pointer;
        outline: none;
        min-width: 110px;
      }
      
      .chart-dropdown select:focus {
        background: #e2e8f0;
      }
    `;
    document.head.appendChild(customStyle);

    return () => {
      document.head.removeChild(customStyle);
    };
  }, []);

  useEffect(() => {
    if (userRole === 4 || userRole === 3) {
      fetchDashboardData();
    }
  }, [dispatch, userRole]);

  // Move this function inside the component but after all hooks
  const fetchDashboardData = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    await dispatch(fetchDashboardCount(userData.UNIT_CENTRE_ID, "grievance"));
    await dispatch(fetchDashboardCount(userData.UNIT_CENTRE_ID, "idcard"));
    await dispatch(fetchDashboardCount(userData.UNIT_CENTRE_ID, "user"));
    await dispatch(fetchDashboardCount(userData.UNIT_CENTRE_ID, "grants"));
    await dispatch(
      fetchDashboardCount(userData.UNIT_CENTRE_ID, "grantsescalarated")
    );
    await dispatch(
      fetchDashboardCount(userData.UNIT_CENTRE_ID, "grievancesescalarated")
    );
    await dispatch(fetchDashboardCount(userData.UNIT_CENTRE_ID, "events"));
    await dispatch(fetchCenters());
  };

  console.log(grantsescalaratedDashboard, grievancesescalaratedDashboard);

  // NOW check for loading and return early if needed - AFTER all hooks
  if (grievancesLoading || grantsLoading) {
    return <Loader message="Loading dashboard data..." />;
  }

  const roleConfig = getRoleConfig(
    userRole,
    grievances,
    grants,
    centerId,
    idCard,
    navigate
  );
  const eventsRawData = eventsDashboard[0];
  const aresaCenterData = [
    {
      name: "Total Aresa Center",
      count: centers?.length,
      color: "#a855f7", // Purple
    },
  ];

  const escalaratedDashboard = [
    {
      name: "Total Escalarated Grants",
      count: grantsescalaratedDashboard[0]?.total_count,
      color: "#8b5a2b", // Purple
    },
    {
      name: "Total Escalarated Grievances",
      count: grievancesescalaratedDashboard[0]?.total_count,
      color: "#059669", // Purple
    },
  ];

  const eventsData = [
    {
      name: "Past Events",
      count: eventsRawData?.past_events,
      color: "#8b5cf6", // Purple
      percentage: (
        (eventsRawData?.past_events / eventsRawData?.total_events) *
        100
      ).toFixed(1),
    },
    {
      name: "Upcoming Events",
      count: eventsRawData?.upcoming_events,
      color: "#06b6d4", // Cyan
      percentage: (
        (eventsRawData?.upcoming_events / eventsRawData?.total_events) *
        100
      ).toFixed(1),
    },
    // Only include today's events if there are any
    ...(eventsRawData?.today_events > 0
      ? [
        {
          name: "Today's Events",
          count: eventsRawData?.today_events,
          color: "#f59e0b", // Amber
          percentage: (
            (eventsRawData?.today_events / eventsRawData?.total_events) *
            100
          ).toFixed(1),
        },
      ]
      : []),
  ];
  const renderStatCard = (card, index) => {
    const statCard = (
      <StatCard
        title={card.title}
        value={card.value}
        icon={card.icon}
        color={card.color}
        additionalInfo={
          card.additionalInfo ? <span>{card.additionalInfo}</span> : null
        }
        onClick={card.onClick}
      />
    );

    // If card has onClick handler, use it instead of Link
    if (card.onClick) {
      return <div key={index}>{statCard}</div>;
    }

    return card.link ? (
      <Link to={card.link} style={{ textDecoration: "none" }} key={index}>
        {statCard}
      </Link>
    ) : (
      <div key={index}>{statCard}</div>
    );
  };

  // Color mapping function for Defense Services Dashboard - Professional Military Theme
  const getStatusColor = (statusName, index) => {
    // Professional color palette for defense services
    const colorPalette = [
      "#1f2937", // Dark slate gray
      "#374151", // Slate gray
      "#4b5563", // Medium gray
      "#6b7280", // Light gray
      "#9ca3af", // Lighter gray
      "#d1d5db", // Very light gray
      "#0f172a", // Navy dark
      "#1e293b", // Navy medium
      "#334155", // Navy light
      "#475569", // Blue gray
    ];

    const lowerStatusName = statusName.toLowerCase();

    // CRITICAL STATUS COLORS (High Priority)
    // Red variants for critical/negative statuses
    if (lowerStatusName.includes("inactive")) {
      return "#dc2626"; // Strong red for inactive
    }
    if (lowerStatusName.includes("rejected")) {
      return "#b91c1c"; // Dark red for rejected
    }
    if (lowerStatusName.includes("denied")) {
      return "#991b1b"; // Darker red for denied
    }

    // GREEN variants for positive/success statuses - Individual colors
    if (lowerStatusName.includes("active")) {
      return "#059669"; // Military green for active
    }
    if (lowerStatusName.includes("approved")) {
      return "#047857"; // Dark green for approved
    }
    if (lowerStatusName.includes("completed")) {
      return "#065f46"; // Darker green for completed
    }
    if (lowerStatusName.includes("disbursed")) {
      return "#064e3b"; // Deep green for disbursed
    }
    if (lowerStatusName.includes("cleared")) {
      return "#022c22"; // Very dark green for cleared
    }

    // Individual colors for specific grant statuses
    if (lowerStatusName.includes("awaiting documents from esm")) {
      return "#d97706"; // Amber for awaiting documents from ESM
    }
    if (lowerStatusName.includes("escalated to next level")) {
      return "#ca8a04"; // Darker amber for escalated to next level
    }
    if (lowerStatusName.includes("grant approval in progress")) {
      return "#a16207"; // Deep amber for grant approval in progress
    }

    // Individual colors for each pending/review status
    if (lowerStatusName.includes("progress")) {
      return "#f59e0b"; // Bright amber for progress
    }
    if (lowerStatusName.includes("pending")) {
      return "#b45309"; // Dark amber for pending
    }
    if (lowerStatusName.includes("awaiting")) {
      return "#92400e"; // Darker amber for awaiting
    }
    if (lowerStatusName.includes("review")) {
      return "#78350f"; // Deep amber for review
    }
    if (lowerStatusName.includes("under review")) {
      return "#451a03"; // Very dark amber for under review
    }

    // Individual colors for informational/process statuses
    if (lowerStatusName.includes("applied")) {
      return "#1d4ed8"; // Military blue for applied
    }
    if (lowerStatusName.includes("raised")) {
      return "#1e40af"; // Darker blue for raised
    }
    if (lowerStatusName.includes("submitted")) {
      return "#1e3a8a"; // Deep blue for submitted
    }
    if (lowerStatusName.includes("processing")) {
      return "#172554"; // Navy blue for processing
    }

    // Individual colors for special/administrative statuses
    if (lowerStatusName.includes("escalated")) {
      return "#7c3aed"; // Purple for escalated
    }
    if (lowerStatusName.includes("priority")) {
      return "#6d28d9"; // Darker purple for priority
    }

    // Individual colors for verification statuses
    if (lowerStatusName.includes("verified")) {
      return "#0d9488"; // Teal for verified
    }
    if (lowerStatusName.includes("validated")) {
      return "#0f766e"; // Darker teal for validated
    }

    // Individual colors for action required statuses
    if (lowerStatusName.includes("action required")) {
      return "#ea580c"; // Orange for action required
    }
    if (lowerStatusName.includes("intervention needed")) {
      return "#c2410c"; // Darker orange for intervention needed
    }

    // Individual colors for administrative statuses
    if (lowerStatusName.includes("archived")) {
      return "#4338ca"; // Indigo for archived
    }
    if (lowerStatusName.includes("closed")) {
      return "#3730a3"; // Darker indigo for closed
    }

    // Default fallback to professional palette
    return colorPalette[index % colorPalette.length];
  };

  // Function to get filtered status counts based on timeframe
  const getFilteredStatusCounts = (data, timeframe) => {
    if (!data) return [];

    let statusCounts;
    switch (timeframe) {
      case "7days":
        statusCounts = data.statusCounts7Days || data.statusCounts;
        break;
      case "15days":
        statusCounts = data.statusCounts15Days || data.statusCounts;
        break;
      case "30days":
        statusCounts = data.statusCounts30Days || data.statusCounts;
        break;
      default:
        statusCounts = data.statusCounts;
    }

    return (
      statusCounts?.map((item, index) => ({
        statusName: item.statusName == "Unknown" ? "Reject" : item.statusName,
        count: parseInt(item.count) || 0,
        color: getStatusColor(item.statusName, index),
      })) || []
    );
  };

  // Function to get filtered total count based on timeframe
  const getFilteredTotalCount = (data, timeframe) => {
    if (!data) return 0;

    switch (timeframe) {
      case "7days":
        return parseInt(data.last7Days) || parseInt(data.totalCount) || 0;
      case "15days":
        return parseInt(data.last15Days) || parseInt(data.totalCount) || 0;
      case "30days":
        return parseInt(data.last30Days) || parseInt(data.totalCount) || 0;
      default:
        return parseInt(data.totalCount) || 0;
    }
  };

  const TimeframeDropdown = ({ value, onChange }) => (
    <div className="chart-dropdown">
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="total">All Time</option>
        <option value="7days">7 Days</option>
        <option value="15days">15 Days</option>
        <option value="30days">30 Days</option>
      </select>
    </div>
  );

  // Get filtered data based on individual timeframes for each card
  const grievanceData = getFilteredStatusCounts(
    grievanceDashborad,
    grievanceTimeframe
  );
  const grantsData = getFilteredStatusCounts(grantDashborad, grantTimeframe);
  const usersData = getFilteredStatusCounts(userDashborad, userTimeframe);
  const idCardData = getFilteredStatusCounts(idcardDashborad, idCardTimeframe);

  // Get filtered totals based on individual timeframes
  const totalGrievances = getFilteredTotalCount(
    grievanceDashborad,
    grievanceTimeframe
  );
  const totalGrants = getFilteredTotalCount(grantDashborad, grantTimeframe);
  const totalUsers = getFilteredTotalCount(userDashborad, userTimeframe);
  const totalIdCards = getFilteredTotalCount(idcardDashborad, idCardTimeframe);

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0];
      return (
        <div
          style={{
            backgroundColor: "white",
            padding: "12px 16px",
            border: "1px solid #e2e8f0",
            borderRadius: "10px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
            fontSize: "14px",
            minWidth: "150px",
          }}
        >
          <p
            style={{
              fontWeight: "600",
              marginBottom: "6px",
              color: "#1f2937",
              fontSize: "15px",
            }}
          >
            {data.payload?.statusName || label}
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <div
              style={{
                width: "12px",
                height: "12px",
                backgroundColor: data.payload?.color || data.color,
                borderRadius: "50%",
              }}
            ></div>
            <span
              style={{
                color: "#374151",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              Count:{" "}
              <strong style={{ color: data.payload?.color || data.color }}>
                {data.value}
              </strong>
            </span>
          </div>
        </div>
      );
    }
    return null;
  };

  const PieChartLegend = ({ data }) => (
    <div className="pie-chart-legend">
      {data.map((entry, index) => (
        <div key={index} className="legend-item-compact">
          <div
            className="legend-color"
            style={{ backgroundColor: entry.color }}
          ></div>
          <span style={{ color: "#6b7280", fontSize: "14px" }}>
            {entry.statusName}:{" "}
            <strong style={{ color: "#374151" }}>{entry.count}</strong>
          </span>
        </div>
      ))}
    </div>
  );

  const CustomTooltip1 = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="bg-white p-3 border rounded shadow-lg">
          <p className="fw-semibold mb-1" style={{ color: data.color }}>
            {data.name}
          </p>
          <p className="mb-0 small text-muted">
            Count: <span className="fw-semibold">{data.count}</span>
          </p>
        </div>
      );
    }
    return null;
  };

  // Legend component
  const PieChartLegend1 = ({ data }) => (
    <div className="mt-3">
      {data.map((item, index) => (
        <div
          key={index}
          className="d-flex align-items-center justify-content-between mb-2"
        >
          <div className="d-flex align-items-center">
            <div
              className="me-2"
              style={{
                width: "12px",
                height: "12px",
                backgroundColor: item.color,
                borderRadius: "2px",
              }}
            ></div>

            <span style={{ color: "#6b7280", fontSize: "14px" }}>
              {item.name}:{" "}
              <strong style={{ color: "#374151" }}>{item.count}</strong>
            </span>
            {/* <span className="small text-muted">{item.name}</span> */}
          </div>
          {/* <div className="text-end">
            <span className="fw-semibold small">{item.count}</span>
          
          </div> */}
        </div>
      ))}
    </div>
  );

  return (
    <div className="container-fluid">
      <DashboardHeader title={roleConfig.title} />
      <div className="stats-grid">
        {roleConfig.statCards.map(renderStatCard)}
      </div>

      {/* Pending Charts Section */}
      {(userRole == 4 || userRole == 6 || userRole == 7) && <div className="row mb-4">
        {/* Grievance Pending At */}
        <div className="col-md-6">
          <div className="chart-container equal-height-card" style={{ height: "360px" }}>
            <h5 className="fw-semibold mb-3" style={{ color: "#1f2937" }}>
              <FileText size={20} className="me-2" style={{ color: "#60a5fa" }} />
              Grievance Pending At
            </h5>
            <div className="chart-content">
              {grievanceDashborad?.pendingByRole && grievanceDashborad.pendingByRole.length > 0 ? (
                <>
                  <ResponsiveContainer width="100%" height={250}>
                    <BarChart
                      data={grievanceDashborad.pendingByRole}
                      onClick={(data) => {
                        if (data && data.activePayload && data.activePayload[0]) {
                          const roleName = data.activePayload[0].payload.roleName;
                          navigate(`/GrievanceList?isPendingAt=${encodeURIComponent(roleName)}`);
                        }
                      }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis
                        dataKey="roleName"
                        angle={-45}
                        textAnchor="end"
                        height={80}
                        fontSize={12}
                      />
                      <YAxis />
                      <Tooltip
                        content={({ active, payload, label }) => {
                          if (active && payload && payload.length) {
                            return (
                              <div className="bg-white p-3 border rounded shadow-lg">
                                <p className="fw-semibold mb-1">{label}</p>
                                <p className="mb-0 small text-muted">
                                  Pending: <span className="fw-semibold">{payload[0].value}</span>
                                </p>
                              </div>
                            );
                          }
                          return null;
                        }}
                      />
                      <Bar dataKey="pendingCount" fill="#60a5fa" barSize={30} />
                    </BarChart>
                  </ResponsiveContainer>
                </>
              ) : (
                <div className="d-flex align-items-center justify-content-center h-100">
                  <p className="text-muted">No Pending Grievance available</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Grants Pending At */}
        <div className="col-md-6">
          <div className="chart-container equal-height-card" style={{ height: "360px" }}>
            <h5 className="fw-semibold mb-3" style={{ color: "#1f2937" }}>
              <Gift size={20} className="me-2" style={{ color: "#10b981" }} />
              Grants Pending At
            </h5>
            <div className="chart-content">
              {grantDashborad?.pendingByRole && grantDashborad.pendingByRole.length > 0 ? (
                <>
                  <ResponsiveContainer width="100%" height={250}>
                    <BarChart
                      data={grantDashborad.pendingByRole}
                      onClick={(data) => {
                        if (data && data.activePayload && data.activePayload[0]) {
                          const roleName = data.activePayload[0].payload.roleName;
                          navigate(`/GrantList?isPendingAt=${encodeURIComponent(roleName)}`);
                        }
                      }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis
                        dataKey="roleName"
                        angle={-45}
                        textAnchor="end"
                        height={80}
                        fontSize={12}
                      />
                      <YAxis />
                      <Tooltip
                        content={({ active, payload, label }) => {
                          if (active && payload && payload.length) {
                            return (
                              <div className="bg-white p-3 border rounded shadow-lg">
                                <p className="fw-semibold mb-1">{label}</p>
                                <p className="mb-0 small text-muted">
                                  Pending: <span className="fw-semibold">{payload[0].value}</span>
                                </p>
                              </div>
                            );
                          }
                          return null;
                        }}
                      />
                      <Bar dataKey="pendingCount" fill="#10b981" barSize={30} />
                    </BarChart>
                  </ResponsiveContainer>
                </>
              ) : (
                <div className="d-flex align-items-center justify-content-center h-100">
                  <p className="text-muted">No Pending Grants available</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>}
      {(userRole === 4 || userRole == 6 || userRole == 7 || (userRole === 3 && centerId == "1")) && (
        <div className="row mb-2">
          {/* Grievance Pie Chart */}
          <div className="col-lg-3 mb-4">
            <div
              className="chart-container equal-height-card"
              style={{ position: "relative" }}
            >
              <TimeframeDropdown
                value={grievanceTimeframe}
                onChange={setGrievanceTimeframe}
              />
              <h5 className="fw-semibold mb-3" style={{ color: "#1f2937" }}>
                <FileText
                  size={20}
                  className="me-2"
                  style={{ color: "#60a5fa" }}
                />
                Grievances
              </h5>
              <div className="chart-content">
                {grievanceData.length > 0 ? (
                  <>
                    <ResponsiveContainer width="100%" height={250}>
                      <PieChart>
                        <Pie
                          data={grievanceData}
                          cx="50%"
                          cy="50%"
                          innerRadius={50}
                          outerRadius={100}
                          // paddingAngle={4}
                          dataKey="count"
                        >
                          {grievanceData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                          ))}
                        </Pie>
                        <Tooltip content={<CustomTooltip />} />
                      </PieChart>
                    </ResponsiveContainer>
                    <PieChartLegend data={grievanceData} />
                  </>
                ) : (
                  <div className="d-flex align-items-center justify-content-center h-100">
                    <p className="text-muted">No data available</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Grants Pie Chart */}
          <div className="col-lg-3 mb-4">
            <div
              className="chart-container equal-height-card"
              style={{ position: "relative" }}
            >
              <TimeframeDropdown
                value={grantTimeframe}
                onChange={setGrantTimeframe}
              />
              <h5 className="fw-semibold mb-3" style={{ color: "#1f2937" }}>
                <Gift size={20} className="me-2" style={{ color: "#10b981" }} />
                Grants
              </h5>
              <div className="chart-content">
                {grantsData.length > 0 ? (
                  <>
                    <ResponsiveContainer width="100%" height={250}>
                      <PieChart>
                        <Pie
                          data={grantsData}
                          cx="50%"
                          cy="50%"
                          innerRadius={50}
                          outerRadius={100}
                          // paddingAngle={4}
                          dataKey="count"
                        >
                          {grantsData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                          ))}
                        </Pie>
                        <Tooltip content={<CustomTooltip />} />
                      </PieChart>
                    </ResponsiveContainer>
                    <PieChartLegend data={grantsData} />
                  </>
                ) : (
                  <div className="d-flex align-items-center justify-content-center h-100">
                    <p className="text-muted">No data available</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* ID Cards Pie Chart */}
          <div className="col-lg-3 mb-4">
            <div
              className="chart-container equal-height-card"
              style={{ position: "relative" }}
            >
              <TimeframeDropdown
                value={idCardTimeframe}
                onChange={setIdCardTimeframe}
              />
              <h5 className="fw-semibold mb-3" style={{ color: "#1f2937" }}>
                <CreditCard
                  size={20}
                  className="me-2"
                  style={{ color: "#f59e0b" }}
                />
                ID Cards
              </h5>
              <div className="chart-content">
                {idCardData.length > 0 ? (
                  <>
                    <ResponsiveContainer width="100%" height={250}>
                      <PieChart>
                        <Pie
                          data={idCardData}
                          cx="50%"
                          cy="50%"
                          innerRadius={50}
                          outerRadius={100}
                          // paddingAngle={4}
                          dataKey="count"
                        >
                          {idCardData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                          ))}
                        </Pie>
                        <Tooltip content={<CustomTooltip />} />
                      </PieChart>
                    </ResponsiveContainer>
                    <PieChartLegend data={idCardData} />
                  </>
                ) : (
                  <div className="d-flex align-items-center justify-content-center h-100">
                    <p className="text-muted">No data available</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* user */}
          {(userRole === 3 || userRole === 4 || userRole === 6 || userRole === 7) && (
            <div className="col-lg-3 mb-4">
              <div
                className="chart-container equal-height-card"
                style={{ position: "relative" }}
              >
                <TimeframeDropdown
                  value={userTimeframe}
                  onChange={setUserTimeframe}
                />
                <h5 className="fw-semibold mb-3" style={{ color: "#1f2937" }}>
                  <Users
                    size={20}
                    className="me-2"
                    style={{ color: "#8b5cf6" }}
                  />
                  Users
                </h5>
                <div className="chart-content">
                  {usersData.length > 0 ? (
                    <>
                      <ResponsiveContainer width="100%" height={250}>
                        <PieChart>
                          <Pie
                            data={usersData}
                            cx="50%"
                            cy="50%"
                            innerRadius={50}
                            outerRadius={100}
                            // paddingAngle={4}
                            dataKey="count"
                          >
                            {usersData.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                          </Pie>
                          <Tooltip content={<CustomTooltip />} />
                        </PieChart>
                      </ResponsiveContainer>
                      <PieChartLegend data={usersData} />
                    </>
                  ) : (
                    <div className="d-flex align-items-center justify-content-center h-100">
                      <p className="text-muted">No data available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* aresa center */}
          {(userRole === 4 || userRole === 6 || userRole === 7) && (
            <div className="col-lg-3 mb-4">
              <div
                className="chart-container equal-height-card"
                style={{ position: "relative" }}
              >
                <h5 className="fw-semibold mb-3" style={{ color: "#1f2937" }}>
                  <Users
                    size={20}
                    className="me-2"
                    style={{ color: "#8b5cf6" }}
                  />
                  Aresa Center
                </h5>
                <div className="chart-content">
                  {aresaCenterData.length > 0 ? (
                    <>
                      <ResponsiveContainer width="100%" height={250}>
                        <PieChart>
                          <Pie
                            data={aresaCenterData}
                            cx="50%"
                            cy="50%"
                            innerRadius={50}
                            outerRadius={100}
                            // paddingAngle={4}
                            dataKey="count"
                          >
                            {aresaCenterData.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                          </Pie>
                          <Tooltip content={<CustomTooltip1 />} />
                        </PieChart>
                      </ResponsiveContainer>
                      <PieChartLegend1 data={aresaCenterData} />
                    </>
                  ) : (
                    <div className="d-flex align-items-center justify-content-center h-100">
                      <p className="text-muted">No data available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* event */}
          {userRole === 4 || userRole === 3 || userRole == 6 || userRole == 7 && (
            <div className="col-lg-3 mb-4">
              <div
                className="chart-container equal-height-card"
                style={{ position: "relative" }}
              >
                <h5 className="fw-semibold mb-3" style={{ color: "#1f2937" }}>
                  <Calendar
                    size={20}
                    className="me-2"
                    style={{ color: "#8b5cf6" }}
                  />
                  Events
                </h5>

                <div className="chart-content">
                  {eventsData.length > 0 ? (
                    <>
                      <ResponsiveContainer width="100%" height={250}>
                        <PieChart>
                          <Pie
                            data={eventsData}
                            cx="50%"
                            cy="50%"
                            innerRadius={50}
                            outerRadius={100}
                            dataKey="count"
                          >
                            {eventsData.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                          </Pie>
                          <Tooltip content={<CustomTooltip1 />} />
                        </PieChart>
                      </ResponsiveContainer>
                      <PieChartLegend1 data={eventsData} />

                      {/* Optional: Display total events count */}
                      <div className="text-center mt-3 pt-2 border-top">
                        <span className="small text-muted">
                          Total Events:{" "}
                          <span className="fw-semibold">
                            {eventsRawData?.total_events}
                          </span>
                        </span>
                      </div>
                    </>
                  ) : (
                    <div className="d-flex align-items-center justify-content-center h-100">
                      <p className="text-muted">No events data available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Escalarated Grants and Grievance */}
          {/* {userRole === 4 && (
            <div className="col-lg-3 mb-4">
              <div
                className="chart-container equal-height-card"
                style={{ position: "relative" }}
              >
                <h5 className="fw-semibold mb-3" style={{ color: "#1f2937" }}>
                  <Users
                    size={20}
                    className="me-2"
                    style={{ color: "#8b5cf6" }}
                  />
                  Escalarated Grants and Grievance
                </h5>
                <div className="chart-content">
                  {escalaratedDashboard.length > 0 ? (
                    <>
                      <ResponsiveContainer width="100%" height={250}>
                        <PieChart>
                          <Pie
                            data={escalaratedDashboard}
                            cx="50%"
                            cy="50%"
                            innerRadius={50}
                            outerRadius={100}
                            // paddingAngle={4}
                            dataKey="count"
                          >
                            {escalaratedDashboard.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                          </Pie>
                          <Tooltip content={<CustomTooltip1 />} />
                        </PieChart>
                      </ResponsiveContainer>
                      <PieChartLegend1 data={escalaratedDashboard} />
                    </>
                  ) : (
                    <div className="d-flex align-items-center justify-content-center h-100">
                      <p className="text-muted">No data available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )} */}
        </div>
      )}

      <div className="content-grid">
        {roleConfig.tables.map((tableConfig) => renderTable(tableConfig))}
      </div>
    </div>
  );
};

export default Dashboard;
